import { render, staticRenderFns } from "./IntegrationItem.vue?vue&type=template&id=bb8b454c&scoped=true&"
import script from "./IntegrationItem.vue?vue&type=script&lang=js&"
export * from "./IntegrationItem.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationItem.vue?vue&type=style&index=0&id=bb8b454c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8b454c",
  null
  
)

export default component.exports